import { Injectable, inject } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';

import { SiteState } from 'src/app/shared/models';

import { hasValidInformation } from '../store/selectors/information.selectors';

@Injectable({
  providedIn: 'root',
})
export class BatchConfigurationAddGuard {
  private readonly router = inject(Router);
  private readonly store = inject<Store<SiteState>>(Store);

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.pipe(
      select(hasValidInformation),
      map((valid) => (!!valid ? true : this.router.parseUrl(`/registration/batches`))),
      take(1),
    );
  }
}
